import { createUseStyles } from 'react-jss';
import { GrayscalePalette, BrandPalette, ActionPalette } from '@tcl-boron-colors/colors';
import { Classes } from 'jss';

export const useTableStyles: () => Classes<'container' | 'table' | 'thead' | 'th' | 'tr' | 'td' | 'tbody'> =
  createUseStyles({
    container: {
      boxShadow: `0 3px 4px 2px ${GrayscalePalette[300]}`,
      width: 'fit-content',
      borderRadius: '10px',
      backgroundColor: GrayscalePalette[100],
    },
    table: {
      borderCollapse: 'separate',
      borderSpacing: 0,
      padding: '24px 24px 0px',
    },
    thead: {
      height: '56px',
      width: '100%',
      backgroundColor: 'white',
    },
    th: {
      border: 'none',
      fontSize: '12px',
      fontWeight: 'bold',
      color: BrandPalette[700],
      letterSpacing: '2px',
      lineHeight: '16px',
      padding: '0px 16px',
      height: '100%',
      textAlign: 'left',
      textTransform: 'uppercase',
      verticalAlign: 'middle',
    },
    tr: {
      width: '100%',
      border: 'none',
      '&:nth-child(even)': {
        backgroundColor: GrayscalePalette[100],
      },
      '&:focus-visible': {
        'box-shadow': `inset 0 0 0 1px ${ActionPalette[300]}`,
        borderRadius: '3px',
        outline: 'none',
      },
      '&:active:not(:focus), &:hover:not(:focus-visible)': {
        'box-shadow': `inset 0 0 0 1px ${ActionPalette[500]}`,
        borderRadius: '3px',
      },
    },
    trHead: {
      width: '100%',
      border: 'none',
      '&:nth-child(even)': {
        backgroundColor: GrayscalePalette[100],
      },
    },
    td: {
      borderTop: '1px solid transparent',
      borderBottom: '1px solid transparent',
      borderLeft: 'none',
      borderRight: 'none',
      fontSize: '14px',
      fontWeight: 'normal',
      letterSpacing: '0px',
      lineHeight: '20px',
      height: '72px',
      color: BrandPalette[700],
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      padding: '19px 16px',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    tbody: {
      backgroundColor: GrayscalePalette[200],
    },
  });
